import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';

function HistoryItem({ item, no }) {
    return (
        <tr>
            <td>{no}</td>
            <td>{item.t_ordername}</td>
            <td>{item.c_title}</td>
            <td>{item.t_ordermost}</td>
            <td>{item.t_duedate}</td>
            <td>{item.t_check}</td>
        </tr>
    );
}
export default function PayHistory({ list }) {
    return (
        <table>
            <thead>
                <tr>
                    <th>No</th>
                    <th>ID</th>
                    <th>{getLocaleWordContent('타입')}</th>
                    <th>{getLocaleWordContent('금액')}</th>
                    <th>{getLocaleWordContent('날짜')}</th>
                    <th>{getLocaleWordContent('상태')}</th>
                </tr>
            </thead>
            <tbody>{list && list.map((item, index) => <HistoryItem key={index} no={index + 1} item={item} />)}</tbody>
        </table>
    );
}
